import {gql} from "apollo-angular";
import {baseResponseGraphqlField} from "../../../base.graphql";
import {designationFields} from "../../instution-settings/designation/designation.graphql";


export const deliveryDurationFields = `
id
stepUniqueId
stepName
stepDecision
stepTimeInYear
stepTimeInMonths
stepTimeInWeeks
stepTimeInDays
stepTimeInHours
stepTimeInMinutes
stepTimeInSec
stepDesignation {
  ${designationFields}
}
parentStep {
        id
        stepUniqueId
        stepName
        stepDecision
        stepTimeInYear
        stepTimeInMonths
        stepTimeInWeeks
        stepTimeInDays
        stepTimeInHours
        stepTimeInMinutes
        stepTimeInSec
        stepDesignation {
          designationName
        }
      }
`



export const CREATE_DELIVERY_PROCEDURE_STEP = gql`
mutation CreateDeliveryProcedureStepMutation($input: ServiceDeliveryProcedureInputObjects!) {
  createDeliveryProcedureStepMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${deliveryDurationFields}
    }
  }
}
`

export const UPDATE_DELIVERY_PROCEDURE_STEP = gql`
mutation UpdateDeliveryProcedureStepMutation($input: DeliveryProcedureStepsInputObjects!) {
  updateDeliveryProcedureStepMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${deliveryDurationFields}
    }
  }
}
`

export const DELETE_DELIVERY_PROCEDURE_STEP = gql`
  mutation DeleteDeliveryProcedureStepMutation($stepUniqueId: String) {
    deleteDeliveryProcedureStepMutation(stepUniqueId: $stepUniqueId) {
    ${baseResponseGraphqlField}
  }
}
`

export const GET_DELIVERY_PROCEDURE_STEP = gql`
  query GetInstitutionServicesDeliveryProcedureSteps($serviceUniqueId: String) {
    getInstitutionServicesDeliveryProcedureSteps(serviceUniqueId: $serviceUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${deliveryDurationFields}
      }
    }
  }
`



